import api from './api';

const getPlatforms = async () => {
    const response = await api.get('/api/platforms');
    return response.data;
};

const getPlatformById = async (id) => {
    const response = await api.get(`/api/platforms/${id}`);
    return response.data;
};

const createPlatform = async (platformData) => {
    const response = await api.post('/api/platforms', platformData);
    return response.data;
};

const updatePlatform = async (id, platformData) => {
    const response = await api.put(`/api/platforms/${id}`, platformData);
    return response.data;
};

const updatePlatformScheduler = async (id, schedulerData) => {
    const response = await api.put(`/api/platforms/${id}/scheduler`, schedulerData);
    return response.data;
};

const deletePlatform = async (id) => {
    const response = await api.delete(`/api/platforms/${id}`);
    return response.data;
};

const getActivePlatforms = async () => {
    const response = await api.get('/api/platforms/active');
    return response.data;
};

const syncTourismotion = async () => {
    const response = await api.post('/api/tourismotion/sync');
    return response.data;
};

const platformService = {
    getPlatforms,
    getPlatformById,
    createPlatform,
    updatePlatform,
    updatePlatformScheduler,
    deletePlatform,
    getActivePlatforms,
    syncTourismotion
};

export default platformService;
